import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import {ValidSelect} from "beaktShared/helpers/validselect";
import Select from 'react-select';
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import Badge from "beaktShared/components/Badge/Badge.js";
import { GerenciaAlertDelete } from "beaktShared/views/Crud/AlertDelete";

// icons
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Search from "@material-ui/icons/Search";
import TimerOffIcon from '@material-ui/icons/TimerOff';
import Edit from "@material-ui/icons/Edit";

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// services
import { formateDate, formateDateandTime, validateDate, convertDate, MaskDate, MaskTime} from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";
import { useGetApi, UseGetApiSimple, UsePostApi, UsePutApi, UseDeleteApi } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { noCaseSensitive } from "beaktShared/helpers/extras";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});


export default function BloqueioAgenda() {
    const { t } = useTranslation(); 
    const session = useContext(SessionContext);
    const classes = useStyles();    

    const { register, setValue, errors, setError, clearError, getValues, handleSubmit } = useForm({mode: "onChange"});
    
    const [loading,setloading] = React.useState(false);
    
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    const [alert,setalert] = React.useState();
    const showAlert = (message, tipo) => {        
        setalert(<SweetAlert
          error={tipo==='error'?true:false}
          warning={tipo==='warning'?true:false}
          success={tipo==='success'?true:false}

          title={t('label.warning')}
          onConfirm={() => setalert(null)}
        >  
        <div dangerouslySetInnerHTML={{ __html: message}} /> 
        </SweetAlert> );
    };

    const intialValues = {
        id: 0,
        profissional:'', 
        motivoBloqueio: ''      
    };
            
    const [{ list, isLoadingList, isErrorGetList }, setListAtualiza] = useGetApi("AgendaBloqueio/" + session.estabelecimentoId);

    const [profissional, setprofissional] = React.useState("");
    const [listSelectProfissional, setlistSelectProfissional] = React.useState([]);
    const loadProfissionais = () =>{  
        const endPoint = "profissionais/agenda/"+session.estabelecimentoId
        UseGetApiSimple(endPoint,0).then(result=>{       
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');                
                return false; 
            }             

            setlistSelectProfissional(result.data);                                      
        });         
    }
    const handleProfissionalChange = event => {
        let value = event
        setprofissional(value);
        setValue("profissional", value);        
        if (value !== "")
            clearError("profissional");                      
    };

    const [tipoRepeticao, settipoRepeticao] = React.useState("");
    const [listSelectTipoRepeticao, setlistSelectTipoRepeticao] = React.useState(["Somente o dia selecionado", "Diário", "Semanal", "Quinzenal", "Mensal", "Anual"]);    
    const handleTipoRepeticao = event => {
        settipoRepeticao(event);
        setValue("tipoRepeticao", event);
    }

    const [repeticao, setrepeticao] = React.useState("");
    const [listSelectRepeticao, setlistSelectRepeticao] = React.useState(["2", "3", "4", "5", "6", "7", "8", "9", "10"]);
    const handleRepeticao = event => {
        setrepeticao(event);
        setValue("repeticao", event);
    }

    useEffect(() => {          
        loadProfissionais();        
    }, []);
    
    const [showModal, setshowModal] = React.useState(false);    
    const handleView = () => {
        setValue("id", 0);
        setprofissional("");
        settipoRepeticao("");
        setrepeticao("");
        setValue("motivoBloqueio", "");
        setValue("data", "");
        setValue("hora", "");
        setValue("duracao", "");
        setshowModal(true);
    }
    const handleEdit = (row) =>{
        setprofissional(row.profissionalId);
        settipoRepeticao(row.tipoRepeticao);                
        setrepeticao(row.repeticao === 0 ? "" : row.repeticao.toString());
        setValue("profissional", row.profissionalId);
        setValue("repeticao", row.repeticao === 0 ? "" : row.repeticao.toString());
        setValue("tipoRepeticao", row.tipoRepeticao);
        setValue("motivoBloqueio", row.motivo);
        setValue("data", formateDate(row.dataBloqueio));
        setValue("hora", row.horaInicio);
        setValue("duracao", parseInt(row.tempoDuracao));
        setValue("id", row.agendaBloqueioId);
                
        setshowModal(true);
    }    

    const [alertDelete, setAlertDelete] = GerenciaAlertDelete();
    const handleDelete = id => {
        var userDeletadoId = session.id;

        UseDeleteApi("AgendaBloqueio/", id, userDeletadoId).then(result => {
            if (result.status !== 200) {
                setAlertDelete({ statusAlert: 2 });
                showNotification(result.message, 'danger');
                return false;
            }

            var listFiltered = list.filter(obj => {
                return obj.agendaBloqueioId !== id;
            });
            setListAtualiza(listFiltered);
            setAlertDelete({ statusAlert: 3 });
            return true;
        });
    };

    const showAlertDelete = id => {
        setAlertDelete({
            statusAlert: 1,
            idToDeleteRecieve: id
        });
    }
    useEffect(() => {
        if (alertDelete.isToDelete)
            handleDelete(alertDelete.idToDeleteSend);          
    }, [alertDelete]);

    const onlyNumbers = (e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') };

    const onSubmit = data => {
    
        let validacao = true;
        if (!validateDate(data.data)) {
            validacao = false;
            setError("data", "invaliddate", t('error_message.invalid_date'));
        }

        if (data.hora.length != 5){
            validacao = false;
            setError("hora", "invaliddate", t('error_message.invalid_date'));
        }

        if (!validacao)
            return;

        var repeticaoInt = (repeticao === "" ? 0 : parseInt(repeticao));
        if (tipoRepeticao === "Diário" || tipoRepeticao === "Somente o dia selecionado")
            repeticaoInt = 0;
        else if (repeticaoInt == 0){
            setError("repeticao", t('label.required'));
            return;
        }        

        var dataC = convertDate(data.data);

        const obj = {
            agendaBloqueioId: data.id,
            estabelecimentoId: session.estabelecimentoId,
            profissionalId: profissional,
            dataBloqueio: dataC,
            horaInicio: data.hora,
            tempoDuracao: parseInt(data.duracao),
            tipoRepeticao: tipoRepeticao,
            repeticao: repeticaoInt,
            motivo: data.motivoBloqueio,
            usuarioCadastroId: session.id
        }
        
        if (obj.agendaBloqueioId > 0){
            setloading(true);
            UsePutApi("AgendaBloqueio", '',obj).then(result=>{                    
                if(result.status !== 200)
                {               
                    setloading(false);
                    showNotification(result.message.message, "danger"); 
                    return false;             
                }

                const updateItemList = list.map(item => item.agendaBloqueioId === result.data.agendaBloqueioId ? result.data : item);
                setListAtualiza(updateItemList);

                showNotification(t('information_message.registered_successfully'), "success"); 
                setshowModal(false);
                setloading(false);
            });
        }
        else{
            setloading(true);
            UsePostApi("AgendaBloqueio",obj).then(result=>{    
                
                if(result.status !== 201)
                {               
                    setloading(false);
                    showNotification(result.message.message, "danger"); 
                    return false;             
                }
                
                const addItemList = [...list, result.data];
                setListAtualiza(addItemList);

                showNotification(t('information_message.registered_successfully'), "success"); 
                setshowModal(false);
                setloading(false);
            });
        }
    }

    const columnsProps = [        
        {
            Header: t('label.professional'),
            accessor: "profissional.nome",            
        },
        {
            Header: t('agenda.block_date'),
            accessor: "dataBloqueio",            
            Cell : (props)=>{
                const custom_date = formateDate(props.value);
                return <span>{custom_date}</span>
            }
        },
        {
            Header: t('agenda.repetition_type'),
            accessor:"tipoRepeticao",            
        },
        {
            Header: t('agenda.reason_for_blocking'),
            accessor: "motivo"            
        },        
    ]
    const columnsAcao = [
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">                    
                    <Button
                        justIcon
                        round
                        simple
                        color="success"
                        className="edit"
                        onClick={() => handleEdit(row.original)}
                    >
                        <Edit />
                    </Button>{" "}
                    <Button
                        justIcon
                        round
                        simple
                        color="danger"
                        className="remove"
                        onClick={() => showAlertDelete(row.original.agendaBloqueioId)}
                    >
                        <Close />
                    </Button>{" "}
                </div>
            ),
            sortable: false,
            filterable: false
        }
    ];

    let columns = [...columnsProps,...columnsAcao];    

    return (
        <div className="maxContent">  
            {notification.show &&
                <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification({show:false})}
                close
                />  
            }                                           
            <GridContainer>
                {alert}
                {loading && 
                    <div className="carregandoCmp">
                        <div className="box">
                            <label>{t('label.loading')} ...</label>
                            <CircularProgress />
                        </div>
                    </div> 
                }
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <TimerOffIcon />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('agenda.calendar_lock')}
                            </h4>
                        </CardHeader>
                        <CardBody>                                                       
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={12} style={{textAlign:"right"}}>
                                    <Button
                                            color="primary"
                                            className={classes.newButton}
                                            onClick={() => handleView(true)}
                                        >
                                            {t('button.new')}
                                    </Button>                            
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <ReactTable
                                        loading = {isLoadingList}
                                        data={list}
                                        columns={columns}
                                        filterable
                                        defaultFilterMethod = {noCaseSensitive}
                                        defaultPageSize={10}
                                        minRows={5}
                                        showPaginationBottom={true}
                                        className="-striped -highlight"
                                        previousText={t('button.previous')}
                                        nextText={t('button.next')}
                                        loadingText={t('label.loading')+"..."}
                                        noDataText={t('information_message.no_records_found')+"!"}
                                        pageText={t('label.page')}
                                        ofText={t('label.of')}
                                        rowsText={t('label.rows')}
                                    />
                                </GridItem>
                            </GridContainer>                            
                        </CardBody>
                    </Card>
                </GridItem>

                {loading && 
                    <div className="carregandoCmp">
                        <div className="box">
                            <label>{t('label.loading')}...</label>
                            <CircularProgress />
                        </div>
                    </div> 
                    }

                <Dialog
                        classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalMedium }}
                        open={showModal}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => setshowModal(false)}
                        aria-labelledby="classic-modal-slide-title"
                        aria-describedby="classic-modal-slide-description"
                        >
                    <DialogTitle
                        id="classic-modal-slide-title"
                        disableTypography
                        className={classes.modalHeader}
                        style={{background:'#5c4477'}}
                    >
                        <Button
                            justIcon
                            className={classes.modalCloseButton}
                            key="close"
                            aria-label="Close"
                            color="transparent"
                            onClick={() => setshowModal(false)}
                        >
                            <Close className={classes.modalClose} />
                        </Button>
                        <h4 className={classes.modalTitle} style={{color:'white'}}>{t('agenda.calendar_lock')}</h4>
                    </DialogTitle>
                    <DialogContent id="classic-modal-slide-description"
                        className={classes.modalBody} 
                    >   
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <input className={classes.hidden} defaultValue={intialValues.id} name="id" ref={register} />
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}> 
                                <br/>
                                <FormControl fullWidth className={classes.formControl}>                                 
                                    <label className={errors.profissional?"select__label select__label_error":"select__label"}>
                                    {t('label.professional')} *</label>
                                    <Select
                                        classNamePrefix="select"
                                        styles={ValidSelect(errors.profissional?true:false)}
                                        isSearchable={true}
                                        name="profissional"
                                        placeholder="Selecione..."
                                        options={listSelectProfissional}
                                        value={listSelectProfissional.filter(({profissionalId}) => profissionalId === profissional)}
                                        getOptionLabel={({nome}) => nome}
                                        getOptionValue={({profissionalId}) => profissionalId}
                                        onChange={(value) => handleProfissionalChange(value.profissionalId !== null ? value.profissionalId : "") }
                                        
                                        ref={() => register(
                                            { name: "profissional" },
                                            { required: true  })
                                        }
                                    />
                                    {errors.profissional &&<FormHelperText className={classes.labelRootError}>
                                        <span>{t('label.required')}</span>
                                    </FormHelperText>}
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={4}>                                 
                                <FormControl fullWidth className={classes.formControl}>                               
                                <TextField                                        
                                    error={errors.data?true:false}
                                    label={t('label.date')+" *"}
                                    variant="outlined"
                                    inputRef={register({required: t('label.required')})}
                                    name="data"
                                    defaultValue={intialValues.data}
                                    InputLabelProps={{shrink: true}}
                                    InputProps={{
                                        inputComponent: MaskDate,
                                    }}  
                                />
                                {errors.data && <FormHelperText className={classes.labelRootError}>
                                    <span>{errors.data.message}</span>
                                </FormHelperText>}
                                </FormControl>                                 
                            </GridItem>
                            <GridItem xs={12} sm={6} md={4}>                                 
                                <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.hora?true:false}
                                        label={t('agenda.start_time')+" *"}
                                        variant="outlined"
                                        inputRef={register({required: true})}
                                        name="hora"
                                        defaultValue={intialValues.hora}
                                        InputLabelProps={{shrink: true}}
                                        InputProps={{
                                        inputComponent: MaskTime,
                                        }} 
                                    />
                                    {errors.hora &&<FormHelperText className={classes.labelRootError}>
                                        <span>{t('label.required')}</span>
                                    </FormHelperText>}
                                </FormControl>                                 
                            </GridItem>
                            <GridItem xs={12} sm={6} md={4}> 
                                <FormControl fullWidth className={classes.formControl}>
                                <TextField                                        
                                    error={errors.duracao?true:false}
                                    label={t('label.duration_minutes')+" *"}
                                    variant="outlined"
                                    name="duracao"
                                    inputRef={register({required: true})}
                                    defaultValue={intialValues.duracao}
                                    InputLabelProps={{shrink: true}}
                                    inputProps={{maxLength: 3}} 
                                    onInput={(e) => onlyNumbers(e) } 
                                />
                                {errors.duracao && <FormHelperText className={classes.labelRootError}>
                                    <span>{t('label.required')}</span>
                                </FormHelperText>}
                                </FormControl>                                 
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}> 
                                <FormControl fullWidth className={classes.formControl}>                                 
                                    <label className={errors.tipoRepeticao?"select__label select__label_error":"select__label"}>
                                    {t('agenda.repetition_type')+" *"}</label>
                                    <Select
                                        classNamePrefix="select"
                                        styles={ValidSelect(errors.tipoRepeticao?true:false)}
                                        isSearchable={true}
                                        name="tipoRepeticao"
                                        placeholder="Selecione..."
                                        options={listSelectTipoRepeticao}
                                        value={listSelectTipoRepeticao.filter(f => f === tipoRepeticao)}
                                        getOptionLabel={(title) => title}
                                        getOptionValue={(title) => title}
                                        onChange={(value) => handleTipoRepeticao(value !== null ? value : "") }
                                        
                                        ref={() => register(
                                            { name: "tipoRepeticao" },
                                            { required: true  })
                                        }
                                    />
                                    {errors.tipoRepeticao &&<FormHelperText className={classes.labelRootError}>
                                        <span>{t('label.required')}</span>
                                    </FormHelperText>}
                                </FormControl>
                            </GridItem>
                            {(tipoRepeticao !== "Diário" && tipoRepeticao !== "Somente o dia selecionado") && 
                                <GridItem xs={12} sm={6} md={6}> 
                                    <FormControl fullWidth className={classes.formControl}>                                 
                                        <label className={errors.repeticao?"select__label select__label_error":"select__label"}>
                                        {t('agenda.repetition')+" *"}</label>
                                        <Select
                                            classNamePrefix="select"
                                            styles={ValidSelect(errors.repeticao?true:false)}
                                            isSearchable={true}
                                            name="repeticao"
                                            placeholder="Selecione..."
                                            options={listSelectRepeticao}
                                            value={listSelectRepeticao.filter(f => f === repeticao)}
                                            getOptionLabel={(title) => title}
                                            getOptionValue={(title) => title}
                                            onChange={(value) => handleRepeticao(value !== null ? value : "") }
                                            
                                            ref={() => register(
                                                { name: "repeticao" },
                                                { required: false  })
                                            }
                                        />
                                        {errors.repeticao &&<FormHelperText className={classes.labelRootError}>
                                            <span>{t('label.required')}</span>
                                        </FormHelperText>}
                                    </FormControl>
                                </GridItem> 
                            }                           
                            <GridItem xs={12} sm={12} md={12}>                                                                 
                                <FormControl fullWidth className={classes.formControl}>
                                <TextField                                        
                                    error={errors.motivoBloqueio?true:false}                                
                                    label={t('agenda.reason_for_blocking')+" *"}
                                    variant="outlined"                                    
                                    defaultValue={intialValues.motivoBloqueio}
                                    InputLabelProps={{shrink: true}}
                                    multiline
                                    rowsMax="3"
                                    rows="2"
                                    name="motivoBloqueio"
                                    inputRef={register({required: true})}                                    
                                    inputProps={{maxLength: 200}}                                    
                                />                                
                                    {errors.motivoBloqueio &&<FormHelperText className={classes.labelRootError}>
                                        <span>{t('label.required')}</span>
                                    </FormHelperText>}
                                </FormControl>                                 
                            </GridItem>
                        </GridContainer>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                                <center>
                                    <br/>
                                    <div className={classes.textCenter}>
                                        <Button color="transparent" onClick={() => setshowModal(false)} className={classes.updateProfileButton}>
                                        {t('button.cancel')} 
                                        </Button>
                                        <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                        {t('button.to_save')}  {loading && <div> ... {t('label.loading')}</div>}                         
                                        </Button>
                                    </div>
                                    <br/>
                                </center>
                            </GridItem>
                        </GridContainer>
                    </form>
                    </DialogContent>
                </Dialog>

            </GridContainer>                             
            {alertDelete.componente}
        </div>
    );
}